<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.22471 9.75121C7.87302 11.0766 8.94739 12.1461 10.2758 12.7884C10.3729 12.8344 10.4804 12.8544 10.5877 12.8463C10.6949 12.8382 10.7982 12.8023 10.8874 12.7421L12.8433 11.4379C12.9298 11.3802 13.0293 11.345 13.1328 11.3355C13.2364 11.326 13.3407 11.3424 13.4362 11.3834L17.0954 12.9516C17.2197 13.0044 17.3234 13.0962 17.3911 13.2131C17.4587 13.33 17.4865 13.4657 17.4702 13.5998C17.3546 14.5048 16.913 15.3366 16.2282 15.9395C15.5434 16.5424 14.6624 16.875 13.75 16.875C10.9321 16.875 8.22956 15.7556 6.23699 13.763C4.24442 11.7705 3.125 9.06794 3.125 6.25002C3.12505 5.33765 3.45765 4.45659 4.06053 3.77179C4.66341 3.087 5.49523 2.64544 6.40023 2.52978C6.53431 2.51356 6.67002 2.54134 6.78693 2.60895C6.90384 2.67657 6.99561 2.78034 7.04841 2.90464L8.61798 6.56698C8.65858 6.66171 8.67512 6.765 8.66614 6.86767C8.65715 6.97034 8.62291 7.0692 8.56647 7.15543L7.26676 9.14135C7.2076 9.23069 7.17263 9.33384 7.16526 9.44073C7.15789 9.54762 7.17837 9.6546 7.22471 9.75121V9.75121Z"
      stroke="#0E0E22"
      stroke-opacity="0.4"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
